import * as React from "react"
import { Unit, Widget, fromJSX } from "widgets-for-react"
import { styleguideChapter } from "../helpers.mod"

export const styleguideGuidelines: Widget<Unit> = styleguideChapter({ type: 'guidelines', slug: 'guidelines', title: 'Design Guidelines', intro: ''})(
      fromJSX(
        _ => (
          <>
            <p className="styleguide-chapter__intro styleguide--styled">Aenean lacinia bibendum nulla sed consectetur. Donec sed odio dui. Curabitur blandit tempus porttitor. Donec ullamcorper nulla non metus auctor fringilla. Donec sed odio dui. Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur.</p>
            <p className="styleguide-chapter__intro styleguide--styled">Etiam porta sem malesuada magna mollis euismod. Nulla vitae elit libero, a pharetra augue. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Vestibulum id ligula porta felis euismod semper. Nullam quis risus eget urna mollis ornare vel eu leo. Nullam quis risus eget urna mollis ornare vel eu leo.</p>
          </>
        )
      )
    )
